<template>
  <el-upload ref="upload" class="upload" :class="{ small: size === 'small' }" drag
    action="/api/help/fileupload/sys/upload" multiple :on-success="handleSuccess" :show-file-list="false"
    :before-upload="defaultBeforeUpload" :on-error="handleError">
    <div class="content">
      <div class="center">
        <img :src="uploadIcon" /><span class="label">点击上传</span>
      </div>
      <div class="tip" v-if="size !== 'small'">请上传所申请的证明材料</div>
    </div>
  </el-upload>
</template>

<script>
import uploadIcon from "@/assets/img/ecology/upload_icon.png";

export default {
  props: {
    size: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      uploadIcon,
    };
  },
  methods: {
    handleError(...res) {
      console.log(res);

    },
    handleSuccess(res, file, fileList) {
      // console.log(res, file, fileList);
      if (res.code === 0) {
        this.$emit("success", res.data);
      } else {
        this.$message.error(res.msg);
      }
    },
    defaultBeforeUpload(file) {
      console.log("defaultBeforeUpload");
      // 上传前校验
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error("上传的附件不得大于100MB");
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.small {
  ::v-deep .el-upload-dragger {
    height: 56px !important;
  }
}

.upload {
  ::v-deep .el-upload-dragger {
    width: 300px;
    height: 80px;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .center {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20px;
  }

  .label {
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    color: #333333;
    margin-left: 8px;
  }

  .tip {
    font-size: 12px;
    text-align: center;
    color: #999999;
    height: 20px;
  }
}
</style>